import { ActionButton, ActionButtonProps } from '@pages/ActionButton';
import { useState } from 'react';

interface LoadingActionButtonProps extends Omit<ActionButtonProps, 'onClick'> {
  children: React.ReactNode;
  loadingText?: string;
  onClick: () => Promise<void> | void;
}

export const LoadingActionButton = ({
  children,
  loadingText = 'Loading...',
  onClick,
  ...props
}: LoadingActionButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      await onClick();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ActionButton onClick={handleClick} disabled={props.disabled || isLoading} {...props}>
      {isLoading ? loadingText : children}
    </ActionButton>
  );
};
